import { Customer } from './getCustomer'
import request, { BASE_URL } from './request'

export interface SaveCustomerArgs {
  telegram_id: string
  first_name: string
  last_name: string
  username: string
  photo_url: string
}

export const saveCustomer = async (args: SaveCustomerArgs): Promise<Customer> =>
  request({
    method: 'POST',
    url: `${BASE_URL}/customers`,
    data: args,
  })
